import { CHANGE_REFILE, GET_REFILLS } from '../actions/refills';

const initialState = {
  requestStatus: '',
  refillsList: [],
  refillTotalPage: 1,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_REFILLS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_REFILLS.SUCCESS: {
      return {
        ...state,
        refillsList: payload.data.data.response,
        refillTotalPage: payload.data.data._meta.pageCount,
        requestStatus: 'success',
      };
    }

    case CHANGE_REFILE: {
      return {
        ...state,
        refillsList: state.refillsList.map((p) => (p.id === payload.id
          ? { ...p, processedOn: payload.value }
          : p)),
      };
    }
    default:
      return state;
  }
};

export default reducer;
